import {Component} from '@angular/core';

import {ContactPage} from '../contact/contact';
import {CrearOrdenPage} from "../crear-orden/crear-orden";
import {DetalleOrdenPage} from "../detalle-orden/detalle-orden";

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {

  tab1Root = CrearOrdenPage;
  tab2Root = DetalleOrdenPage;
  tab3Root = ContactPage;

  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts